import React, { FC, memo, useMemo } from 'react'
import { Container, InnerContainer, TrustItemsContainer } from './styles'
import TrustBarItem, { TrustBarItemData } from './trust-bar-item'
import AccommodationIcon from '../../../assets/icons/accommodation.svg'
import PeopleIcon from '../../../assets/icons/people.svg'
import HeartIcon from '../../../assets/icons/heart-outline.svg'
import LegacyIcon from '../../../assets/icons/legacy.svg'
import TrustBarTransport from '../../../transports/common/trustbar-transport'

const TRUST_PILOT_IMAGES = {
    DESKTOP: '/assets/images/trust-bar/trust-pilot.jpg',
    MOBILE: '/assets/images/trust-bar/trust-pilot-mobile.jpg',
}

const HOLIDAYMAKER_TRUST_COUNT = 45
const RECOMMENDATIONS_PERCENTAGE = 99
const LEGACY_YEARS = 20
const FALLBACK_ACCOMMODATIONS_COUNT = 100_233

const BASE_TRUST_BAR_ITEMS: TrustBarItemData[] = [
    {
        id: 'trustpilot',
        icon: TRUST_PILOT_IMAGES.DESKTOP,
        mobileIcon: TRUST_PILOT_IMAGES.MOBILE,
        translationKey: '',
        number: null,
        isImage: true,
    },
    {
        id: 'accommodations',
        icon: AccommodationIcon,
        translationKey: 'trustbarAccommodations',
        number: null,
    },
    {
        id: 'bookings',
        icon: PeopleIcon,
        translationKey: 'holidaymakerTrustCount',
        number: HOLIDAYMAKER_TRUST_COUNT,
    },
    {
        id: 'recommendations',
        icon: HeartIcon,
        translationKey: 'recommendationsText',
        number: RECOMMENDATIONS_PERCENTAGE,
    },
    {
        id: 'legacy',
        icon: LegacyIcon,
        translationKey: 'legacyTrust',
        number: LEGACY_YEARS,
    },
]

interface TrustBarProps {
    trustBar: TrustBarTransport
}

const TrustBar: FC<TrustBarProps> = ({ trustBar }) => {
    const totalOnlineListingsCount = useMemo(
        () => trustBar?.totalOnlineListingsCount || FALLBACK_ACCOMMODATIONS_COUNT,
        [trustBar?.totalOnlineListingsCount],
    )

    const trustBarItems = useMemo(
        () =>
            BASE_TRUST_BAR_ITEMS.map(item => ({
                ...item,
                number: item.id === 'accommodations' ? totalOnlineListingsCount : item.number,
            })),
        [totalOnlineListingsCount],
    )

    return (
        <Container id="trust-bar">
            <InnerContainer>
                <TrustItemsContainer>
                    {trustBarItems.map(item => (
                        <TrustBarItem key={item.id} item={item} />
                    ))}
                </TrustItemsContainer>
            </InnerContainer>
        </Container>
    )
}

export default memo(TrustBar)
